import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import NotificationSent from "./NotificationSent";
import log from '../image/circular_notices.mp4'

const CircularNotice = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [subject, setSubject] = useState("");
  const [isPinned, setIsPinned] = useState(false);
  const [isStarred, setIsStarred] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedNotice, setSelectedNotice] = useState(null);
  const [isComposingNew, setIsComposingNew] = useState(false);
  const [noticeContent, setNoticeContent] = useState("");
  const [activeFilters, setActiveFilters] = useState({
    status: "all",
    priority: "all",
    type: "all",
  });
  const [searchQuery, setSearchQuery] = useState("");

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // Sample notices data


  const stats = {
    total: 24,
    unread: 3,
    pinned: 2,
    today: 1,
  };

  const handleNoticeClick = (notice) => {
    setSelectedNotice(notice);
    setIsComposingNew(false);
    setSubject(notice.title);
  };

  const handleNewNoticeClick = () => {
    setIsComposingNew(true);
    setSelectedNotice(null);
    setSubject("");
    setNoticeContent("");
    setIsPinned(false);
    setIsStarred(false);
  };

  const handleCancelCompose = () => {
    setIsComposingNew(false);
    setSelectedNotice(null);
    setSubject("");
    setNoticeContent("");
  };

  const handleFilterChange = (filterType, value) => {
    setActiveFilters((prev) => ({
      ...prev,
      [filterType]: value,
    }));
  };

  const handleSendNotice = () => {
    if (!subject.trim()) {
      alert("Please enter a subject for the notice.");
      return;
    }

    alert(`Notice "${subject}" has been sent to all members!`);

    // Reset form
    setIsComposingNew(false);
    setSubject("");
    setNoticeContent("");
    setIsPinned(false);
    setIsStarred(false);
  };

  const handleSaveDraft = () => {
    if (!subject.trim()) {
      alert("Please enter a subject for the notice.");
      return;
    }

    alert(`Notice "${subject}" has been saved as draft.`);
    setIsComposingNew(false);
    setSubject("");
    setNoticeContent("");
    setIsPinned(false);
    setIsStarred(false);
  };


  return (
    <div className="app-container">
    

      <Header toggleSidebar={toggleSidebar} />
      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
        <main className="content-area">
          <SubHeader />
          <div
  style={{
    width: "100%",
    maxWidth: "1100px",
    borderRadius: "28px",
    overflow: "hidden",
    boxShadow: "0 25px 60px rgba(0,0,0,0.15)",
    transition: "0.4s ease",
    margin: "0 auto",
  }}
>
  <video
    src={log}
    autoPlay
    loop
    muted
    playsInline
    style={{
      width: "100%",
      height: "auto",
      aspectRatio: "16 / 9",
      objectFit: "cover",
      display: "block",
    }}
  />
</div>
        </main>
      </div>
    </div>
  );
};

export default CircularNotice;
